import React from 'react'
import Header from "../Global/Header"
import Sidebar from "../Global/Sidebar"
import Footer from "../Global/Footer"
import Content from "../Global/content"
import { withRouter } from "react-router-dom"

const useViewportWidth = () => {
    const [width, setWidth] = React.useState(window.innerWidth)
    
    React.useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    
    return width
}

const Layout = ({ children }) => {
    const [toggleMenu, setToggleMenu] = React.useState(false)
    const viewportWidth = useViewportWidth()
    const isSmallScreen = viewportWidth <= 1024 // Match your CSS breakpoint
    
    const toggleMenuCallback = () => {
        const sidebar = document.getElementById("sidebar")
        const content = document.getElementById("content")
        
        if (!sidebar || !content) return
        
        if (toggleMenu) {
            sidebar.classList.remove("open")
            content.classList.remove("open")
            setToggleMenu(false)
        } else {
            sidebar.classList.add("open")
            content.classList.add("open")
            setToggleMenu(true)
        }
    }
    
    // Close menu when resizing from small to large screen
    React.useEffect(() => {
        if (!isSmallScreen && toggleMenu) {
            const sidebar = document.getElementById("sidebar")
            const content = document.getElementById("content")
            if (sidebar && content) {
                sidebar.classList.remove("open")
                content.classList.remove("open")
                setToggleMenu(false)
            }
        }
    }, [isSmallScreen, toggleMenu])
    
    return(
        <React.Fragment>
            <Sidebar id="sidebar" toggleMenuCallback={toggleMenuCallback} />
            <div id="content" className="content">
                <Header 
                    toggleMenuCallback={toggleMenuCallback} 
                    title="Canvas Express"
                    isSmallScreen={isSmallScreen}
                />
                <Content toggleMenuCallback={toggleMenuCallback} body={children} />
            </div>
            <Footer />
        </React.Fragment>
    )
}

export default withRouter(Layout)